import { NgModule, PLATFORM_ID, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SanitizeHtmlPipe, SanitizeUrlPipe } from './pipes/sanitize-html.pipe';
import { SimplifyStringPipe } from './pipes/simplifyString.pipe';
import { SecondsToMinutesPipe } from './pipes/seconds-minutes.pipe';
import { AdaptiveBackgroundImageDirective } from './directives/adaptive-image/adaptive-background-image.directive';
import { AdaptiveImageDirective } from './directives/adaptive-image/adaptive-image.directive';
import { EventListenerDirective } from './directives/event-listener.directive';
import { LazyImageDirective } from './directives/lazy-image.directive';
import { LazyModuleDirective } from './directives/lazy-module.directive';
import { LazyViewDirective } from './directives/lazy-view.directive';
import { SafeUrlPipe } from './pipes/safe-url';
import { RouterModule } from '@angular/router';
import { ConsentedDirective } from './directives/consented/consented.directive';
import { LazyViewport } from './services/lazy-loader-v2.service';
import { WebViewRouterLinkDirective } from './directives/webview-router-link.directive';

@NgModule({
  declarations: [
    SanitizeHtmlPipe,
    SanitizeUrlPipe,
    SimplifyStringPipe,
    SecondsToMinutesPipe,
    AdaptiveBackgroundImageDirective,
    AdaptiveImageDirective,
    EventListenerDirective,
    LazyImageDirective,
    LazyModuleDirective,
    LazyViewDirective,
    SafeUrlPipe,
    ConsentedDirective,
    WebViewRouterLinkDirective,
  ],
  exports: [
    SanitizeUrlPipe,
    SanitizeHtmlPipe,
    SimplifyStringPipe,
    SecondsToMinutesPipe,
    AdaptiveBackgroundImageDirective,
    AdaptiveImageDirective,
    EventListenerDirective,
    LazyImageDirective,
    LazyModuleDirective,
    LazyViewDirective,
    SafeUrlPipe,
    ConsentedDirective,
    WebViewRouterLinkDirective,
  ],
  imports: [CommonModule, RouterModule],
  providers: [
    {
      provide: LazyViewport,
      useFactory: function () {
        const platformId = inject(PLATFORM_ID);
        const viewport = new LazyViewport(platformId);
        viewport.setup();
        return viewport;
      },
    },
  ],
})
export class AngularSharedUtilNmoModule {}
